import "./App.css";
import S from "./Pages/Cart/S";
import LoginPage from "./Pages/Login_Signup/Login.jsx";
import AllRoutes from "./Routes/AllRoutes";

function App() {
	return (
		<>
	
			<AllRoutes />
			<S/>
			{/* <LoginPage /> */}
			{/* <LoginSignup /> */}
			{/* <Navbar /> */}
		</>
	);
}

export default App;
